// apps/admin/src/features/notifications/NotificationFeedListener.tsx
//
// Render-less global mount for the TopBar bell's REST hydrate + WS refresh
// (issue #2555). Sibling of SystemEventListener / SupportTicketListener —
// mount once inside the authenticated shell.
//
// Must be mounted exactly once: `useNotificationStore` is a singleton, so a
// second mount would duplicate the fetch and the WS subscriptions.

import type { JSX } from 'react';

import { useNotificationFeed } from './useNotificationFeed.js';

export function NotificationFeedListener(): JSX.Element {
  useNotificationFeed();
  return (
    <span
      aria-hidden="true"
      data-testid="notification-feed-listener"
      className="sr-only"
    />
  );
}

export default NotificationFeedListener;
